(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Controller = App.loadClass('core::Angular/Controller');

  exports.PracticesController = (function(superClass) {
    extend(PracticesController, superClass);

    function PracticesController(scope, transitions, modal, http, service, state1) {
      var fn, i, len, property, ref;
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state1;
      this.irrigatedDrylandChanged = bind(this.irrigatedDrylandChanged, this);
      this.irrigatedProjectedChanged = bind(this.irrigatedProjectedChanged, this);
      this.calculateDefaultDrylandProjected = bind(this.calculateDefaultDrylandProjected, this);
      this.calculateDefaultIrrigatedProjected = bind(this.calculateDefaultIrrigatedProjected, this);
      this.irrigatedChanged = bind(this.irrigatedChanged, this);
      this.openLimeDialog = bind(this.openLimeDialog, this);
      this.openCropResidueRemovedDialog = bind(this.openCropResidueRemovedDialog, this);
      this.openPestMgmtDialog = bind(this.openPestMgmtDialog, this);
      this.irrigationMapHasDetails = bind(this.irrigationMapHasDetails, this);
      this.irrigationMapHasCrop = bind(this.irrigationMapHasCrop, this);
      this.irrigationMapExists = bind(this.irrigationMapExists, this);
      PracticesController.__super__.constructor.apply(this, arguments);
      this.scope.$watch('service.fpcResult.data.economic_value_for_grain', (function(_this) {
        return function(value, oldValue) {
          if (value > 100) {
            _this.service.fpcResult.data.economic_value_for_grain = 100;
          } else if (value < 0) {
            _this.service.fpcResult.data.economic_value_for_grain = 0;
          }
          if (value < 100 && value !== oldValue && oldValue !== void 0) {
            return _this.service.fpcResult.data.crop_residue_removed = true;
          }
        };
      })(this));
      this.scope.$watch('service.fpcResult.data.water_applied', (function(_this) {
        return function(value, oldValue) {
          if (value < 0) {
            return _this.service.fpcResult.data.water_applied = oldValue;
          }
        };
      })(this));
      this.scope.$watch('service.fpcResult.data.previous_crop_residue_removed', (function(_this) {
        return function(value, oldValue) {
          var ref;
          if ((oldValue === void 0 || oldValue === false) && value === true) {
            if (!_this.service.fpcResult.data.selected_previous_crop) {
              _this.service.fpcResult.data.selected_previous_crop = (ref = _this.service.previousCrop) != null ? ref.crop : void 0;
            }
            if ((_this.service.previousCrop != null) && !_this.service.fpcResult.data.previous_crop_yield) {
              return _this.service.fpcResult.data.previous_crop_yield = _this.service.previousFieldprintCropYield.estimated_yield;
            }
          } else if (oldValue === true && value === false) {
            _this.service.fpcResult.data.selected_previous_crop = null;
            return _this.service.fpcResult.data.previous_crop_yield = null;
          }
        };
      })(this));
      ref = ['dryland_projected', 'dryland_actual', 'irrigated_projected', 'irrigated_actual'];
      for (i = 0, len = ref.length; i < len; i++) {
        property = ref[i];
        fn = (function(_this) {
          return function(prop) {
            return _this.scope.$watch("service.fpcResult.data." + prop, function(value, oldValue) {
              if (value > 10000) {
                return _this.service.fpcResult.data[prop] = oldValue;
              }
            });
          };
        })(this);
        fn(property);
      }
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          var ref1, ref2, ref3, ref4;
          if (((_this.service.fpcResult.data.manual_irrigated == null) || !_this.service.fpcResult.data.manual_irrigated) && _this.irrigationMapHasCrop() && _this.irrigationMapHasDetails()) {
            _this.service.fpcResult.data.irrigated = true;
          }
          if (!_this.irrigationMapHasCrop() || !_this.irrigationMapHasDetails()) {
            _this.service.fpcResult.data.irrigated = false;
          }
          if ((_this.service.fpcResult.data.manual_irrigated_projected == null) && _this.irrigationMapExists()) {
            _this.service.fpcResult.data.irrigated_projected = _this.calculateDefaultIrrigatedProjected();
          }
          if ((_this.service.fpcResult.data.manual_dryland_projected == null) && _this.irrigationMapExists()) {
            _this.service.fpcResult.data.dryland_projected = _this.calculateDefaultDrylandProjected();
          }
          _this.service.fpcResult.data.dryland_actual = parseInt(((ref1 = _this.service.fpcResult.irrigation_map) != null ? (ref2 = ref1.average_yield) != null ? ref2.dryland : void 0 : void 0) + 0.5);
          _this.service.fpcResult.data.irrigated_actual = parseInt(((ref3 = _this.service.fpcResult.irrigation_map) != null ? (ref4 = ref3.average_yield) != null ? ref4.irrigated : void 0 : void 0) + 0.5);
          if (!_this.service.fpcResult.data.dryland_actual) {
            _this.service.fpcResult.data.dryland_actual = parseInt(_this.service.fpcResult.average_yield + 0.5);
          }
          if (!_this.service.fpcResult.data.dryland_actual) {
            _this.service.fpcResult.data.dryland_actual = null;
          }
          if (!_this.service.fpcResult.data.dryland_actual && !_this.service.fpcResult.data.dryland_actual) {
            return _this.service.fpcResult.data.yield_to_use = 'projected';
          }
        };
      })(this));
      this.service.onSaveTriggers.push((function(_this) {
        return function() {
          var resetIfBeyondLimits;
          resetIfBeyondLimits = function(prop, min, max) {
            if (_.get(_this.service, prop) && (_.get(_this.service, prop) < min || _.get(_this.service, prop) > max)) {
              return _.set(_this.service, prop, null);
            }
          };
          resetIfBeyondLimits('fpcResult.data.water_applied', _this.service.irrigationValidationValues().min, _this.service.irrigationValidationValues().max);
          resetIfBeyondLimits('fpcResult.data.deep_aquifer_ground_water_applied', _this.service.irrigationValidationValues().min, _this.service.irrigationValidationValues().max);
          resetIfBeyondLimits('fpcResult.data.irrigated_projected', _this.service.validationCropValues[_this.service.crop].min, _this.service.validationCropValues[_this.service.crop].max);
          return resetIfBeyondLimits('fpcResult.data.dryland_projected', _this.service.validationCropValues[_this.service.crop].min, _this.service.validationCropValues[_this.service.crop].max);
        };
      })(this));
    }

    PracticesController.prototype.irrigationMapExists = function() {
      return this.service.fpcResult.irrigation_map != null;
    };

    PracticesController.prototype.irrigationMapHasCrop = function() {
      var ref, ref1, ref2;
      return this.irrigationMapExists() && (ref = this.service.mfCrop, indexOf.call((ref1 = this.service.fpcResult.irrigation_map) != null ? (ref2 = ref1.extra_info) != null ? ref2.crops : void 0 : void 0, ref) >= 0);
    };

    PracticesController.prototype.irrigationMapHasDetails = function() {
      var ref;
      return ((ref = this.service.fpcResult.irrigation_map) != null ? ref.details : void 0) != null;
    };

    PracticesController.prototype.openPestMgmtDialog = function() {
      return this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'backend/grower/fieldprint/pest-mgmt-dialog',
        controller: 'DialogController'
      });
    };

    PracticesController.prototype.openCropResidueRemovedDialog = function() {
      return this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'views/grower/fieldprint/crop-residue-dialog',
        controller: 'Fieldprint.Controllers.CropResidueRemovedController'
      });
    };

    PracticesController.prototype.openLimeDialog = function() {
      return this.modal.open({
        windowClass: 'modal-width',
        templateUrl: 'views/grower/fieldprint/applied-lime-dialog',
        controller: 'Fieldprint.Controllers.LimeController'
      });
    };

    PracticesController.prototype.irrigatedChanged = function() {
      var dlg, message, newscope, state, title;
      if (this.service.fpcResult.data.irrigated && (!this.irrigationMapExists() || !this.irrigationMapHasCrop() || !this.irrigationMapHasDetails())) {
        if (!this.irrigationMapExists()) {
          title = 'Add Irrigation Map';
          message = "You have indicated that " + this.service.fpcResult.field_name + " is irrigated, but we have no Irrigation<br>map on record. Would you like to create one now?";
          state = 'grower.fieldprint-define';
        } else if (!this.irrigationMapHasCrop()) {
          title = 'Edit Irrigation Map';
          message = "You have indicated that " + this.service.fpcResult.field_name + " is irrigated, but the Irrigation<br>map on record does not have data for " + this.service.mfCrop + ". Would you like to edit it now?";
          state = 'grower.fieldprint-add-crop-irrigation';
        } else if (!this.irrigationMapHasDetails()) {
          title = 'Add Irrigation Details';
          message = "You have indicated that " + this.service.fpcResult.field_name + " is irrigated, but the Irrigation<br>map on record does not include Irrigation Details. Would you like to add them now?";
          state = 'grower.fieldprint-add-crop-irrigation';
        }
        newscope = this.scope.$new();
        newscope.title = title;
        newscope.body = message;
        dlg = this.modal.open({
          templateUrl: 'backend/core/confirm-dialog',
          controller: 'ConfirmDialogController',
          scope: newscope
        });
        return dlg.result.then((function(_this) {
          return function() {
            _this.service.fpcResult.data.manual_irrigated = false;
            _this.service.fpcResult.data.irrigated = false;
            return _this.service.save(_this.service.fpcResult.id).then(function() {
              var ref, ref1;
              return _this.state.go(state, {
                request: JSON.stringify({
                  year: _this.service.year,
                  field_id: _this.service.field,
                  crop: _this.service.mfCrop,
                  layer_id: (ref = _this.service.fpcResult.irrigation_map) != null ? ref.id : void 0,
                  layers_title: (ref1 = _this.service.fpcResult.irrigation_map) != null ? ref1.name : void 0,
                  redirectId: _this.state.params.id,
                  redirectState: 'fieldprint',
                  step: _this.state.params.step
                })
              });
            });
          };
        })(this), (function(_this) {
          return function() {
            return _this.service.fpcResult.data.irrigated = false;
          };
        })(this));
      } else {
        return this.service.fpcResult.data.manual_irrigated = true;
      }
    };

    PracticesController.prototype.calculateDefaultIrrigatedProjected = function() {
      var range, ref, ref1;
      if (!((ref = this.service.fpcResult.irrigation_map) != null ? ref.extra_info.mappings[this.service.mfCrop] : void 0)) {
        return '';
      }
      range = (ref1 = this.service.fpcResult.irrigation_map) != null ? ref1.extra_info.mappings[this.service.mfCrop].irrigated_range : void 0;
      if (!range) {
        return '';
      }
      return Math.round((range.min + range.max) / 2);
    };

    PracticesController.prototype.calculateDefaultDrylandProjected = function() {
      var range, ref, ref1;
      if (!((ref = this.service.fpcResult.irrigation_map) != null ? ref.extra_info.mappings[this.service.mfCrop] : void 0)) {
        return '';
      }
      range = (ref1 = this.service.fpcResult.irrigation_map) != null ? ref1.extra_info.mappings[this.service.mfCrop].dryland_range : void 0;
      if (!range) {
        return '';
      }
      return Math.round((range.min + range.max) / 2);
    };

    PracticesController.prototype.irrigatedProjectedChanged = function() {
      if (this.service.fpcResult.data.irrigated_projected === 0) {
        this.service.fpcResult.data.irrigated_projected = this.calculateDefaultIrrigatedProjected();
        return this.service.fpcResult.data.manual_irrigated_projected = false;
      } else {
        return this.service.fpcResult.data.manual_irrigated_projected = true;
      }
    };

    PracticesController.prototype.irrigatedDrylandChanged = function() {
      if (this.service.fpcResult.data.dryland_projected === 0) {
        this.service.fpcResult.data.dryland_projected = this.calculateDefaultDrylandProjected();
        return this.service.fpcResult.data.manual_dryland_projected = false;
      } else {
        return this.service.fpcResult.data.manual_dryland_projected = true;
      }
    };

    return PracticesController;

  })(Controller);

}).call(this);
